import ListWrapper from 'components/ListWrapper';
import {useContext, useState} from 'react';
import FormGroup from 'components/FormGroup';
import TextField from 'components/TextField';
import {useForm} from 'react-hook-form';
import Button from 'components/Button';
import CardContent from 'components/CardContent';
import FormActionGroup from 'components/FormActionGroup';
import {SelectOption, User} from 'types';
import {OnboardingContext} from '../../Onboarding';
import api from 'api';
import {get} from 'lodash';
import toast from 'react-hot-toast';
import Typography from 'components/Typography';
import {validateEmail} from 'utils/validators';
import {phoneFormat} from 'helpers/phoneFormat';
import EyeIcon from '../../../EmployeeForm/icons/eye.svg';
import EyeDisabledIcon from '../../../EmployeeForm/icons/eye-disable.svg';
import styles from './style.module.scss';
import useAuth from 'hooks/useAuth';
import {useHistory} from 'react-router-dom';

type FormValue = {
  driver: SelectOption[];
  name: string;
  model: string;
  travel_method: SelectOption;
  first_name: string;
  last_name: string;
  field_memebers: any[];
  email: string;
  phone: string;
  password: string;
  is_active: boolean;
  password_confirmation: string;
};

function Team() {
  const history = useHistory();
  const {setUser, currentUser} = useAuth();
  const {data, setData} = useContext(OnboardingContext);
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const {
    handleSubmit,
    register,
    watch,
    formState: {errors},
  } = useForm<FormValue>({
    defaultValues: {
      name: get(data, 'team.name', ''),
      model: get(data, 'team.model', 'Car'),
      driver: get(data, 'team.drivers', '')
        ? get(data, 'team.drivers', []).map((d: any) => ({
            value: d.id,
            label: d.first_name + ' ' + d.last_name,
            isActive: d.is_active === 'True',
          }))
        : undefined,
      travel_method: {
        value: get(data, 'team.travel_method', 'car'),
        label: get(data, 'team.travel_method') === 'bike' ? 'Bike' : 'Car',
      },
    },
  });

  const onSubmit = async (values: FormValue) => {
    if (get(data, 'team.id', 0)) {
      setData({...data, step: 4});
      return;
    }
    try {
      setIsLoading(true);
      const {data: user} = await api.post<User>('/users/', {
        ...values,
        is_active: true,
        phone: values.phone.replace(/\D/g, ''),
        role: 'driver',
      });
      await api.post('/teams/', {
        ...values,
        color: '#4000FF',
        travel_method: values.travel_method.value,
        drivers: [user.driver_id],
      });

      const {data: order} = await api.post('/requests/create-order/', {
        customer_id: get(data, 'customer.id', ''),
        address_id: get(data, 'customer.address.id', ''),
        drugs: [get(data, 'offering.id', '')],
      });

      await api.get(
        `/requests/${order.sequential_order_number}/?is_sequential_order_number=true`
      );
      toast.success('Congratulations, welcome to the dashboard!');
      await api.post('/users/onboard/', {
        is_onboarded: true,
      });

      if (currentUser) setUser({...currentUser, is_onboarded: true});
      history.replace('/orders');
    } catch (error) {
      const message = get(error, 'response.data[0]', 'Something went wrong');
      toast.error(message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Typography variant="h4">
        <b>Onsite Worker</b> - They will receive job in the "Jobs App"
      </Typography>
      <ListWrapper>
        <CardContent px="md" pt="none" pb="md">
          <FormGroup columns={1}>
            <TextField
              label="Team Name"
              placeholder="Name"
              {...register('name', {required: 'Required'})}
              error={errors.name?.message}
            />
          </FormGroup>

          <FormGroup columns={2}>
            <TextField
              label="First Name"
              placeholder="First Name"
              {...register('first_name', {required: 'Required'})}
              error={errors.first_name?.message}
            />
            <TextField
              label="Last Name"
              placeholder="Last Name"
              {...register('last_name', {required: 'Required'})}
              error={errors.last_name?.message}
            />
          </FormGroup>

          <FormGroup columns={2}>
            <TextField
              label="Email"
              placeholder="Email"
              {...register('email', {
                required: 'Required',
                validate: validateEmail,
              })}
              error={errors.email?.message}
            />
            <TextField
              label="Phone Number"
              placeholder="(123) 456-7890"
              {...register('phone', {
                required: 'Required',
                validate: (val: string) => {
                  if (val.length !== 14) {
                    return 'Phone number must be 14 numbers';
                  }
                },
              })}
              type="tel"
              minLength={14}
              onChange={(e) => {
                e.target.value = phoneFormat(e.target.value);
              }}
              error={errors.phone?.message}
            />
          </FormGroup>

          <FormGroup columns={2}>
            <div style={{position: 'relative'}}>
              <TextField
                label="Password"
                type={showPassword ? 'text' : 'password'}
                placeholder="Password"
                {...register('password', {
                  required: 'Required',
                })}
                error={errors.password?.message}
              />
              <img
                onClick={() => setShowPassword((pr) => !pr)}
                className={styles.eyeIcon}
                src={showPassword ? EyeIcon : EyeDisabledIcon}
                alt="eye"
              />
            </div>
            <div style={{position: 'relative'}}>
              <TextField
                label="Password Confirmation"
                type={showPassword1 ? 'text' : 'password'}
                placeholder="Password Confirmation"
                {...register('password_confirmation', {
                  required: 'Required',
                  validate: (val: string) => {
                    if (watch('password') !== val) {
                      return 'Your passwords do no match';
                    }
                  },
                })}
                error={errors.password_confirmation?.message}
              />
              <img
                onClick={() => setShowPassword1((pr) => !pr)}
                className={styles.eyeIcon}
                src={showPassword1 ? EyeIcon : EyeDisabledIcon}
                alt="eye"
              />
            </div>
          </FormGroup>
        </CardContent>
      </ListWrapper>
      <FormActionGroup
        style={{justifyContent: 'center', marginTop: 50, padding: 20}}
      >
        <Button
          onClick={() => setData({...data, step: data.step - 1})}
          color="blue"
        >
          Prev
        </Button>
        <Button onClick={handleSubmit(onSubmit)} loading={isLoading}>
          Next
        </Button>
      </FormActionGroup>
    </>
  );
}

export default Team;
